import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=65469e3d&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=js"
export * from "./Diagnostic.vue?vue&type=script&lang=js"
import style0 from "./Diagnostic.vue?vue&type=style&index=0&id=65469e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65469e3d",
  null
  
)

export default component.exports